"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var resource_1 = require("./resource");
var resource = "autocomplete/addresses";
exports.create = function (client) {
    var list = resource_1.listMethod({
        resource: resource,
        client: client,
    });
    return { list: list };
};
//# sourceMappingURL=autocomplete.js.map